export type SearchType = 'flight_number' | 'route' | 'departure' | 'arrival'

export type FlightStatus =
    | 'SCHEDULED'
    | 'EN_ROUTE'
    | 'ENROUTE'
    | 'LANDED'
    | 'RESCHEDULED'
    | 'CANCELLED_BY_AIRLINE'
    | 'ON_TIME'
    | 'EARLY'
    | 'LATE'
    | string

export type ActiveTab = 'departures' | 'arrivals'

export interface SearchIntent {
    departureAirport: string | null
    arrivalAirport: string | null
    date: string | null
    airlineCode: string | null
    flightNo: string | null
    departureAirportName: string | null
    arrivalAirportName: string | null
    departureCityName?: string | null
    arrivalCityName?: string | null
    departureCountryCode?: string | null
    arrivalCountryCode?: string | null
    departureAirportFullName?: string | null
    arrivalAirportFullName?: string | null
}

export interface FlightStatusCardData {
    airline: {
        airlineName: string
        airlineCode: string
        flightNo: number
        codeShareInfo?: { isCodeShareAirline?: boolean; codeShareText?: string }
    }
    flightStatus: FlightStatus
    departure: {
        airportCode: string
        scheduledTime: string
        updatedTime?: string | null
        flightStatus?: FlightStatus
    }
    arrival: {
        airportCode: string
        scheduledTime: string
        updatedTime?: string | null
        flightStatus?: FlightStatus
    }
    durationMinutes: number
    flightTrackerId: string
}

export interface AirlineFilterOption {
    airlineCode: string
    airlineName: string
}

export interface TimeFilterData {
    airportCode: string
    options: string[]
}

export interface FlightStatusFilterData {
    airlines: AirlineFilterOption[]
    departureTimeFrom: TimeFilterData | null
    arrivalTimeFrom: TimeFilterData | null
}

export interface SelectedFlightStatusFilters {
    airlines: string[]
    departureTime: string[]
    arrivalTime: string[]
}

export interface FlightStatusResponse {
    searchIntent: SearchIntent
    cards: FlightStatusCardData[]
    filterData?: FlightStatusFilterData
}

export interface FlightStatusQueryParams {
    type: SearchType
    date: string
    carrierCode?: string
    flightNumber?: string
    dep?: string
    arr?: string
}

export interface FlightStatusState {
    searchIntent: SearchIntent | null
    cards: FlightStatusCardData[]
    filterData: FlightStatusFilterData | null
    selectedFilters: SelectedFlightStatusFilters
    isLoading: boolean
    error: string
    activeTab: ActiveTab
    searchType: SearchType | null
}

export const INITIAL_FILTERS: SelectedFlightStatusFilters = {
    airlines: [],
    departureTime: [],
    arrivalTime: [],
}
